import { makeStyles } from 'tss-react/mui';

const PASTE_STATE_BUTTON_WIDTH = 69;

export const useCombinationPasteStateButtonStyles = makeStyles()((theme) => ({
  base: {
    width: PASTE_STATE_BUTTON_WIDTH,
    paddingInline: theme.spacing(0.75),
    borderRadius: theme.shape.borderRadiusMd,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    columnGap: theme.spacing(0.25),
    whiteSpace: 'nowrap',

    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
      margin: 0,
    },
  },
  pasteButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': { backgroundColor: theme.palette.primary.dark },
  },
  pastedButton: {
    paddingLeft: theme.spacing(0.5),
    fontSize: theme.typography.micro1.fontSize,
    backgroundColor: theme.palette.action.selected,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.secondary,
    },
  },
  copiedButton: {
    paddingRight: theme.spacing(0.5),
    fontSize: theme.typography.micro1.fontSize,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    border: `1.5px dashed ${theme.palette.accent.main}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      border: `1.5px dashed ${theme.palette.accent.main}`,
    },
  },
  invalidButton: {
    fontSize: theme.typography.micro1.fontSize,
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
      border: `1px solid ${theme.palette.custom.border.primary}`,
    },
  },
}));
